<div class="container bg-header" style="background-color: rgb(105, 69, 175) !important;">
  <div class="row">
    <div class="col-8">
      <h1 mat-dialog-title class="text-white p-3 m-0" style="color: white !important;">Available Documents</h1>
    </div>
    <div class="col-4 d-flex justify-content-end align-items-center">
      <p role="button" (click)="closeModal()" class="text-white m-0">Cancel</p>
      <mat-icon class="ml-1" (click)="closeModal()">cancel</mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content class="m-3">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="badge badge-info">
            {{ selectedDocuments.length }}
            {{ selectedDocuments.length === 1 ? 'Document Selected' : 'Documents Selected' }}
          </span>
          <div>
            <button type="button" class="button-primary mr-2" mat-button (click)="selectAll()">
              <i class="icon-Forward-arrow-small"></i>
              Select All
            </button>
            <button type="button" class="button-primary" mat-button (click)="clearSelection()">
              <i class="icon-Backward-arrow-small"></i>
              Clear
            </button>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="documents-table" *ngIf="availableDocuments.length > 0">
          <div class="table-header">
            <div class="header-cell checkbox-col">
              <mat-checkbox
                [checked]="selectedDocuments.length === availableDocuments.length && availableDocuments.length > 0"
                [indeterminate]="selectedDocuments.length > 0 && selectedDocuments.length < availableDocuments.length"
                (change)="selectedDocuments.length === availableDocuments.length ? clearSelection() : selectAll()">
              </mat-checkbox>
            </div>
            <div class="header-cell document-col">Document</div>
            <div class="header-cell type-col">Type</div>
            <div class="header-cell size-col">Size</div>
            <div class="header-cell date-col">Upload Date</div>
          </div>

          <div class="table-body">
            <div *ngFor="let document of availableDocuments"
                 class="table-row"
                 [class.selected]="isDocumentSelected(document)"
                 (click)="toggleDocumentSelection(document)">
              <div class="table-cell checkbox-col">
                <mat-checkbox
                  [checked]="isDocumentSelected(document)"
                  (click)="$event.stopPropagation()"
                  (change)="toggleDocumentSelection(document)">
                </mat-checkbox>
              </div>
              <div class="table-cell document-col">
                <div class="document-info">
                  <mat-icon [class]="getDocumentIconColor(document.type)" class="document-icon">
                    {{ getDocumentIcon(document.type) }}
                  </mat-icon>
                  <div class="document-details">
                    <div class="document-name">{{ document.name }}</div>
                  </div>
                </div>
              </div>
              <div class="table-cell type-col">
                <span class="type-badge">{{ document.type }}</span>
              </div>
              <div class="table-cell size-col">
                {{ document.size }}
              </div>
              <div class="table-cell date-col">
                {{ document.uploadDate | date:'dd/MM/yyyy' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="availableDocuments.length === 0">
        <div class="text-center py-4">
          <mat-icon style="font-size: 3rem; color: #ccc;">folder_open</mat-icon>
          <p class="text-muted mt-2">No documents available</p>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-container container py-5 mb-3">
    <button class="button-primary float-left" mat-button (click)="closeModal()">
      <i class="icon-Backward-arrow-small"></i>
      Cancel
    </button>
    <button
      class="button-primary float-right"
      [disabled]="selectedDocuments.length === 0"
      mat-button
      (click)="confirmSelection()">
      <i class="icon-Forward-arrow-small"></i>
      Confirm Selection ({{ selectedDocuments.length }})
    </button>
  </div>
</div>